import { Injectable } from '@angular/core';
import {DashboardGrid} from '../models/dashboard';
import {GridsterItem} from 'angular-gridster2';
import {Categories} from '../models/chart';
import {GridItemFactoryService} from './grid-item-factory.service';

@Injectable({
  providedIn: 'root',
})
export class GridVersionManagerService {

  currentVersion: [number, number, number] = [0,0,2];

  constructor() { }

  needUpdate(versionString: string | undefined): boolean {
    if(versionString === undefined){
      return true;
    }
    const splitVersion = versionString.split('.');
    for (let i = 0; i < this.currentVersion.length; i++){
      if(Number(splitVersion[i]) !== this.currentVersion[i]){
        return true;
      }
      if(i === this.currentVersion.length - 1 && Number(splitVersion[i]) === this.currentVersion[i]){
        return false;
      }
    }
    return true;
  }

  updateGridVersion(dashboardGrid: DashboardGrid): DashboardGrid{
    if(dashboardGrid.version === undefined){
      return this.updateToVersion0o0o2(dashboardGrid);
    }
    return dashboardGrid;
  }

  updateToVersion0o0o2(dashboardGrid: DashboardGrid): DashboardGrid{
    const dashboardGridTemp = dashboardGrid as unknown as GridsterItem[];
    dashboardGrid = {
      version: undefined,
      grid: dashboardGridTemp,
    };
    dashboardGrid.grid.forEach(grid => {
      if(grid.type === Categories.chart){
        grid.minItemCols = 3;
        grid.minItemRows = 2;
      }
    });
    dashboardGrid.version = this.currentVersion.toString().replaceAll(',','.');
    return dashboardGrid;
  }

}
